import { g, remove, add } from '../other/function.js';

class Drop {
  constructor({ selector, autoClose = true, isToggle = true }) {
    this.autoClose = autoClose;
    this.selector = selector;
    this.items = g(selector, document, true)?.reverse();
    this.isToggle = isToggle;
    this.initDrop(true);
  }

  initDrop(flag) {
    if (!this.items) return;
    const faq = g(`${this.selector} .content`, document, true);
    faq?.forEach((item) => {
      if (flag) item.setAttribute('data-height', `${item.offsetHeight}px`);
      item.style.height = '0px';
    });
  }

  closeDrop() {
    if (!this.items) return;
    remove(this.items);
    this.initDrop();
  }

  onClick(target) {
    if (!this.items) return;
    const item = target.closest(this.selector);
    if (this.isToggle) {
      if (item.classList.contains('active')) {
        if (this.autoClose) {
          this.closeDrop();
        } else {
          remove(item);
          item.querySelector('.content').style.height = '0px';
        }
      } else {
        if (this.autoClose) this.closeDrop();
        add(item);
        const content = item.querySelector(':scope > .content');
        content.style.height = content.getAttribute('data-height');
      }
    } else {
      add(item);
      const content = item.querySelector(':scope > .content');
      content.style.height = content.getAttribute('data-height');
    }
  }
}

export default Drop;
